import React, { useEffect, useState, useCallback } from "react";
import { useUser } from "../shared/UserContext";
import { listEndedEmergencies, startEmergency } from "../shared/emergencyData";
import EmergencyRecap from "./EmergencyRecap";
import "./Checklist.css"; // reuse the .emg-past* row styles

// Admin-only Settings tab: run a practice drill, and review past drills &
// emergencies (each opens its recap). This history used to sit inline on the
// Check List screen; it belongs here, out of the everyday teacher's way.
export default function SafetySettings() {
  const { schoolId, user, teacherName } = useUser();
  const [pastDrills, setPastDrills] = useState([]);
  const [selectedPast, setSelectedPast] = useState(null);
  const [starting, setStarting] = useState(false);

  const load = useCallback(() => {
    if (!schoolId) return;
    listEndedEmergencies(schoolId)
      .then(setPastDrills)
      .catch((e) => console.error("[Safety] past drills load:", e));
  }, [schoolId]);

  useEffect(() => { load(); }, [load]);

  const startDrill = async () => {
    const ok = window.confirm(
      "Start a school-wide practice DRILL now?\n\nEvery staff member will be alerted to account for their students.",
    );
    if (!ok) return;
    setStarting(true);
    try {
      await startEmergency(schoolId, user, teacherName, true);
    } catch (e) {
      console.error("[Safety] start drill:", e);
      window.alert("Couldn't start the drill — check your connection and try again.");
    } finally {
      setStarting(false);
    }
  };

  if (selectedPast) {
    return <EmergencyRecap emergency={selectedPast} onClose={() => { setSelectedPast(null); load(); }} />;
  }

  return (
    <div className="settings-section">
      <h2>Safety &amp; drills</h2>
      <p className="settings-intro">
        Run a practice drill, and review past drills &amp; emergencies. To start a real
        emergency, use the <strong>🚨 Start Emergency</strong> button in the menu.
      </p>

      <button className="btn-drill" onClick={startDrill} disabled={starting || !schoolId}>
        {starting ? "Starting…" : "Start a practice drill"}
      </button>

      <h3 style={{ marginTop: 28 }}>Past drills &amp; emergencies</h3>
      {pastDrills.length === 0 ? (
        <p className="settings-note">No drills or emergencies recorded yet.</p>
      ) : (
        <div className="emg-past-list">
          {pastDrills.map((e) => {
            const start = e.startedAt ? new Date(e.startedAt) : null;
            const durMs = e.startedAt && e.endedAt
              ? new Date(e.endedAt).getTime() - new Date(e.startedAt).getTime() : null;
            const durLabel = durMs == null ? "" :
              durMs < 60000 ? `${Math.round(durMs / 1000)}s` : `${Math.round(durMs / 60000)}m`;
            return (
              <button key={e.id} className="emg-past-row" onClick={() => setSelectedPast(e)}>
                <span className={`emg-kind-badge ${e.isDrill ? "is-drill" : "is-real"}`}>
                  {e.isDrill ? "DRILL" : "EMERGENCY"}
                </span>
                <span className="emg-past-when">
                  {start ? start.toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—"}
                </span>
                {durLabel && <span className="emg-past-dur">{durLabel}</span>}
                <span className="emg-past-arrow">View recap ›</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
